<template>
    <MainLayout>
        <div class="container">
            <div class="box">
                <div class="row">
                    <div class="col-12">
                        <h2>Suscripción de eventos</h2>
                        <hr>
                    </div>
                </div>
            
                <div class="row">
                    <!-- Events List -->
                    <div class="col-md-4 border-right">
                        <div>
                            <h5>Eventos disponibles</h5>
                            <div class="card-body px-0" style="height: 700px; overflow-y: scroll;">
                                <div class="list-group" v-if="!loading">
                                    <a 
                                        v-for="event in availableEvents" 
                                        :key="event.id"
                                        href="#" 
                                        class="list-group-item list-group-item-action py-2"
                                        :class="{ 'active': selectedEvent && selectedEvent.id == event.id }"
                                        @click="selectEvent(event)"
                                    >
                                        <div class="d-flex w-100 justify-content-between">
                                            <h6 class="mb-0 pb-0"><strong>{{ event.name }}</strong></h6>
                                        </div>
                                        <div>
                                            <b-badge v-if="!loading" variant="info">
                                                Suscripciones {{ getSubscriptionCount(event.id) }}
                                            </b-badge>
                                            <b-spinner v-else small label="cargando.."></b-spinner>
                                        </div>
                                        <p class="mb-1">{{ event.description }}</p>
                                        <small class="text-muted"> > {{ event.id }}</small>
                                    </a>
                                </div>
                                <div v-else class="text-center mx-auto">
                                    <b-spinner  class="m-5" label="cargando.." variant="primary"></b-spinner>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Subscriptions Management -->
                    <div class="col-md-8">
                        <div v-if="selectedEvent" class="">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h6>Suscripciones para: <strong>{{ selectedEvent.name }}</strong></h6>
                                <b-button 
                                    v-if="$hasPermission('eventsSubscriptions.add')" 
                                    variant="primary" 
                                    @click="newSubscription"
                                >
                                    <md-icon icon="add" /> Nueva suscripción
                                </b-button>
                            </div>
                            <div class="card-body px-0">
                                <!-- Subscriptions List -->
                                <div v-if="eventSubscriptions(selectedEvent.id).length > 0">
                                    <div 
                                        v-for="subscription in eventSubscriptions(selectedEvent.id)" 
                                        :key="subscription.id"
                                        class="card mb-3"
                                    >
                                        <div class="card-body">
                                            <div class="d-flex justify-content-between align-items-start">
                                                <div class="flex-grow-1">
                                                    <div v-if="subscription.status == 'inactive'">
                                                        <span class="badge badge-warning text-white text-uppercase">Desactivado</span>
                                                    </div>
                                                    <h6 class="card-title">
                                                        <span class="badge badge-primary mr-2">{{ subscription.platform }}</span><strong>{{ subscription.name }}</strong>
                                                    </h6>
                                                    <div class="card-text">
                                                        <span class="badge badge-info mr-2">{{ subscription.method.toUpperCase() }}</span>
                                                        <strong>URL:</strong> {{ subscription.url }}
                                                    </div>
                                                    <div class="card-text" v-if="subscription.flowId">
                                                        <strong>ID flujo:</strong> {{ subscription.flowId }}
                                                    </div>
                                                    <div class="card-text" v-if="subscription.notes">
                                                        <strong>Notas:</strong> {{ subscription.notes }}
                                                    </div>
                                                </div>
                                                <div class="ml-3">
                                                    <b-button 
                                                        size="sm" 
                                                        variant="outline-secondary" 
                                                        class="mr-1"
                                                        @click="viewLogs(subscription)"
                                                        title="Ver logs"
                                                    >
                                                        <md-icon icon="history" />
                                                    </b-button>
                                                    <b-button 
                                                        v-if="$hasPermission('eventsSubscriptions.edit')" 
                                                        size="sm" 
                                                        variant="outline-info" 
                                                        class="mr-1"
                                                        @click="editSubscription(subscription)"
                                                    >
                                                        <md-icon icon="edit" />
                                                    </b-button>
                                                    <b-button 
                                                        v-if="$hasPermission('eventsSubscriptions.delete')" 
                                                        size="sm" 
                                                        variant="outline-danger"
                                                        @click="deleteSubscription(subscription)"
                                                    >
                                                        <md-icon icon="delete" />
                                                    </b-button>
                                                </div>
                                            </div>
                                            
                                            <!-- Test Webhook Section -->
                                            <div class="testing-webhook-area mt-3">
                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                    <small class="text-muted">Prueba de webhook</small>
                                                    <b-button 
                                                        size="sm" 
                                                        variant="outline-secondary"
                                                        @click="toggleTestForm(subscription.id)"
                                                    >
                                                        <md-icon :icon="testVisible[subscription.id] ? 'expand_less' : 'expand_more'" />
                                                        {{ testVisible[subscription.id] ? 'Ocultar' : 'Mostrar' }} prueba
                                                    </b-button>
                                                </div>
                                                
                                                <b-collapse :visible="testVisible[subscription.id]">
                                                    <div class="card">
                                                        <div class="card-body p-3">
                                                            <b-form @submit.prevent="testSubscription(subscription)">
                                                                <div class="form-group">
                                                                    <label for="reservation-id" class="form-label">ID de Reservación</label>
                                                                    <div class="input-group">
                                                                        <b-form-input 
                                                                            id="reservation-id" 
                                                                            v-model="reservationIdTest" 
                                                                            required
                                                                            placeholder="Ingrese el ID de la reservación"
                                                                            :disabled="testLoading[subscription.id]"
                                                                        />
                                                                        <div class="input-group-append">
                                                                            <b-button 
                                                                                type="submit" 
                                                                                variant="primary"
                                                                                :disabled="testLoading[subscription.id] || !reservationIdTest"
                                                                            >
                                                                                <b-spinner v-if="testLoading[subscription.id]" small class="mr-1" />
                                                                                <md-icon v-else icon="send" class="mr-1" />
                                                                                {{ testLoading[subscription.id] ? 'Enviando...' : 'Enviar' }}
                                                                            </b-button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </b-form>
                                                            
                                                            <!-- Response Area -->
                                                            <div v-if="testResponse[subscription.id]" class="mt-3">
                                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                                    <h6 class="mb-0">Respuesta del webhook</h6>
                                                                    <small class="text-muted">{{ testResponse[subscription.id].timestamp }}</small>
                                                                </div>
                                                                
                                                                <div 
                                                                    class="alert" 
                                                                    :class="{
                                                                        'alert-success': testResponse[subscription.id].success,
                                                                        'alert-danger': !testResponse[subscription.id].success
                                                                    }"
                                                                >
                                                                    <div v-if="testResponse[subscription.id].success">
                                                                        <strong>✓ Éxito</strong>
                                                                        <div class="mt-2">
                                                                            <strong>Status HTTP:</strong> {{ testResponse[subscription.id].status }}
                                                                        </div>
                                                                        <div class="mt-2">
                                                                            <strong>Respuesta:</strong>
                                                                            <pre class="mt-1 mb-0 bg-light p-2 rounded"><code>{{ formatResponse(testResponse[subscription.id].response) }}</code></pre>
                                                                        </div>
                                                                    </div>
                                                                    <div v-else>
                                                                        <strong>✗ Error</strong>
                                                                        <div class="mt-2">{{ testResponse[subscription.id].error }}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="eventSubscriptions(selectedEvent.id).length == 0 && !loading" 
                                    class="text-center text-muted py-5">
                                    <p>No hay suscripciones para este evento</p>
                                    <b-button 
                                        v-if="$hasPermission('eventsSubscriptions.add')" 
                                        variant="primary" 
                                        @click="newSubscription"
                                    >
                                        Crear primera suscripción
                                    </b-button>
                                </div>
                                <div v-if="loading" class="text-center mx-auto">
                                    <b-spinner  class="m-5" label="cargando.." variant="primary"></b-spinner>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-center text-muted py-5">
                            <p>Selecciona un evento para ver y gestionar sus suscripciones</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Subscription Form Modal -->
        <b-modal 
            ref="subscriptionModal" 
            :title="editingSubscription ? 'Editar suscripción' : 'Nueva suscripción'"
            @hidden="resetForm"
            size="lg"
            hide-footer
        >
            <b-form @submit.prevent="saveSubscription">
                <b-row>
                    <b-form-group class="col-md-6" label="Nombre del flujo" label-for="subscription-name">
                        <b-form-input 
                            id="subscription-name" 
                            v-model="subscriptionForm.name" 
                            required
                            placeholder="Ej: Notificación a sistema externo"
                        />
                    </b-form-group>

                    <b-form-group class="col-md-3" label="Método HTTP" label-for="subscription-method">
                        <b-form-select 
                            id="subscription-method" 
                            v-model="subscriptionForm.method" 
                            :options="httpMethods"
                            required
                        />
                    </b-form-group>

                    <b-form-group class="col-md-3" label="Plataforma" label-for="subscription-platform">
                        <b-form-select 
                            id="subscription-platform" 
                            v-model="subscriptionForm.platform" 
                            :options="platforms"
                            required
                        />
                    </b-form-group>
                </b-row>

                <b-form-group label="URL del webhook" label-for="subscription-url">
                    <b-form-input 
                        id="subscription-url" 
                        v-model="subscriptionForm.url" 
                        type="url"
                        required
                        placeholder="https://ejemplo.com/webhook"
                    />
                </b-form-group>

                <b-form-group label="Id de flujo" label-for="subscription-flow-id">
                    <b-form-input 
                        id="subscription-flow-id" 
                        v-model="subscriptionForm.flowId"
                        placeholder=""
                    />
                </b-form-group>

                <b-row class="py-3">
                    <b-form-group class="col-md-6 pb-3" label="Proveedor">
                        <multiselect
                            id="suppliers"
                            :options="supplierOptions"
                            v-model="subscriptionForm.suppliers"
                            :multiple="true"
                            :show-labels="false"
                            placeholder="Todos"
                            label="text"
                            track-by="value"
                            taggable>
                            <template v-slot:clear >
                                <div class="multiselect__clear" @click="subscriptionForm.suppliers = []">
                                </div>
                            </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-md-6 pb-3" label="Canal de venta">
                        <multiselect
                            id="salesChannels"
                            v-model="subscriptionForm.salesChannels"
                            :options="channelOpts"
                            multiple
                            label="text"
                            track-by="value"
                            placeholder="Todos"
                            taggable>
                            <template v-slot:clear >
                                <div class="multiselect__clear" @click="subscriptionForm.salesChannels = []">
                                </div>
                            </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-md-12 pb-3" label="Zonas">
                        <multiselect 
                            id="zones"
                            v-model="subscriptionForm.zones"
                            :options="zonedAreasGroupedOpts"
                            :multiple="true"
                            group-values="zones"
                            group-label="zonedArea"
                            :group-select="true"
                            placeholder="Type to search"
                            track-by="text"
                            label="text">
                            <span slot="noResult">Oops! No se encontraron resultados.</span>
                            <template v-slot:clear >
                                <div class="multiselect__clear" @click="subscriptionForm.zones = []"></div>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc" v-if="props.option.$groupLabel">
                                    <span class="option__title">{{ props.option.$groupLabel }}</span><br>
                                </div>
                                <div class="option__desc"  v-else>
                                    <span class="option__title">{{ props.option.text }}</span><br>
                                    <small class="option__small text-muted">
                                        {{ props.option.zonedAreaName }}
                                    </small>
                                </div>
                            </template>
                            <template slot="option-group" slot-scope="props">
                                <div class="option__desc">
                                    <span class="option__title">{{ props.option.text }}</span><br>
                                    <small class="option__small text-muted">
                                    {{ props.option.zonedAreaName }}
                                    </small>
                                </div>
                            </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-md-12 pb-3" label="Filtros">
                        <multiselect
                            id="filters"
                            v-model="subscriptionForm.extraFilters"
                            :options="filterOptions"
                            multiple
                            label="text"
                            track-by="value"
                            placeholder="Todos"
                            taggable>
                            <template v-slot:clear >
                                <div class="multiselect__clear" @click="subscriptionForm.extraFilters = []">
                                </div>
                            </template>
                        </multiselect>
                    </b-form-group>
                </b-row>

                <b-form-group label="Estado" label-for="subscription-status">
                    <b-form-select 
                        id="subscription-status" 
                        v-model="subscriptionForm.status" 
                        :options="status"
                        required
                    />
                </b-form-group>

                <b-form-group label="Notas" label-for="subscription-notes">
                    <b-form-textarea 
                        id="subscription-notes" 
                        v-model="subscriptionForm.notes" 
                        rows="4"
                        placeholder="Notas adicionales sobre esta suscripción"
                    />
                </b-form-group>


                <b-button variant="primary" class="float-right mt-3" type="submit">Guardar</b-button>

            </b-form>
        </b-modal>

        <!-- Event Subscription Logs Modal -->
        <EventSubscriptionLogs
            v-if="selectedSubscriptionForLogs"
            :subscription="selectedSubscriptionForLogs"
            modal-id="event-subscription-logs-modal"
        />
    </MainLayout>
</template>

<script>
    import MainLayout from '../layout/MainLayout.vue'
    import EventSubscriptionLogs from './EventSubscriptionLogs.vue'
    import Multiselect from "vue-multiselect";

    export default {
        components: {MainLayout, EventSubscriptionLogs, Multiselect},
        data() {
            return {
                selectedEvent: null,
                editingSubscription: false,
                loading: false,
                subscriptionForm: {
                    name: '',
                    url: '',
                    method: 'POST',
                    data: '',
                    notes: '',
                    eventId: null,
                    flowId: null,
                    platform: 'BIRD',
                    status: 'active',
                    id: null,
                    salesChannels: [],
                    suppliers: [],
                    zones: [],
                    extraFilters: []
                },
                availableEvents: [],
                subscriptions: [],
                httpMethods: [
                    { value: 'GET', text: 'GET' },
                    { value: 'POST', text: 'POST' },
                    { value: 'PUT', text: 'PUT' },
                    { value: 'PATCH', text: 'PATCH' },
                    { value: 'DELETE', text: 'DELETE' }
                ],
                platforms: [
                    { value: 'BIRD', text: 'BIRD' }
                ],
                status: [
                    { value: 'active', text: 'Activo' },
                    { value: 'inactive', text: 'Inactivo' }
                ],
                reservationIdTest: '',
                testingSubscription: null,
                testVisible: {},
                testResponse: {},
                testLoading: {},
                selectedSubscriptionForLogs: null,
                filterOptions: [
                    { value: 'email_empty',       text: 'Sin Email' },
                    { value: 'email_valid',       text: 'Email válido' },
                    { value: 'phone_empty',       text: 'Sin Teléfono' },
                    { value: 'phone_invalid',     text: 'Telefono Inválido' },
                    { value: 'phone_valid',       text: 'Telefono válido' },
                    { value: 'flight_info_empty', text: 'Sin Informacion de Vuelo'}
                ]
            }
        },
        mounted() {
            //this.loadSubscriptions();
            this.loadAllowedEvents()

            this.$root.auxVars.loadResourcesOpts({
                vm: this, 
                resourceNames: [
                    'salesChannelsOpts',
                    'masterZonedAreasOpts',
                    'zonedAreasOpts',
                    'suppliersOpts',
                    'transportServiceStatusOpts'
                ]
            })
        },
        computed: {
            eventSubscriptions() {
                return (eventId) => {
                    return this.subscriptions.filter(sub => sub.eventId === eventId);
                };
            },

            supplierOptions() {
                let aux= [...this.$root.auxVars.suppliersOpts.map((sc) => ({
                    value: sc.id,
                    text: sc.name,
                    }))];
                return aux;
            },

            channelOpts(){
                let aux= [...this.$root.auxVars.salesChannelsOpts.map((sc) => ({
                    value: sc.id,
                    text: sc.code,
                    }))];
                return aux;
            },

            zonedAreasGroupedOpts() {
                let grouped = [];
                this.$root.auxVars.masterZonedAreasOpts.forEach((ele)=>{
                    let item = {
                        zonedArea:ele.name,
                        zones:ele.zones.map((aux)=>({value:aux.id,text:aux.name,zonedAreaName:ele.name}))
                    };
                    grouped.push(item)
                })
                return grouped
            },

            zonedAreasOpts() {
                let aux= [...this.$root.auxVars.zonedAreasOpts.map((sc) => ({
                    value: sc.id,
                    text: sc.name,
                    }))];
                return aux;
            }

        },
        methods: {
            selectEvent(event) {
                this.selectedEvent = event;
            },
            
            getSubscriptionCount(eventId) {
                return this.subscriptions.filter(sub => sub.eventId === eventId).length;
            },
            

            newSubscription() {
                this.editingSubscription = false;
                this.subscriptionForm.eventId = this.selectedEvent.id;
                this.$refs.subscriptionModal.show();
            },
            
            editSubscription(subscription) {
                this.editingSubscription = true;
                this.subscriptionForm = { ...subscription };

                let salesChannels = this.channelOpts.filter(sc => 
                    subscription.salesChannels.includes(sc.value)
                );

                let suppliers = this.supplierOptions.filter(sc => 
                    subscription.suppliers.includes(sc.value)
                );

                let zones = [];
                this.$root.auxVars.masterZonedAreasOpts.forEach((ele) => {
                    ele.zones.forEach((zone) => {
                        if (subscription.zones.includes(zone.id)) {
                            zones.push({
                                value: zone.id,
                                text: zone.name,
                                zonedAreaName: ele.name
                            });
                        }
                    });
                });

                let selectedFilters = this.filterOptions.filter(sc => 
                    subscription.extraFilters.includes(sc.value)
                );

                this.subscriptionForm.salesChannels = salesChannels;
                this.subscriptionForm.suppliers     = suppliers;
                this.subscriptionForm.zones         = zones;
                this.subscriptionForm.extraFilters  = selectedFilters;
                
                this.$refs.subscriptionModal.show();
            },
            
            deleteSubscription(subscription) {
                this.$bvModal.msgBoxConfirm('¿Realmente desea eliminar esta suscripción?', {
                    title: 'Eliminar suscripción',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Sí, eliminar',
                    cancelTitle: 'Cancelar',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    if(value){
                        this.loading = true;
                        let rParams = {
                            url: `/event-subscriptions/${subscription.id}`,
                            method: "delete",
                        };
                        this.$root.api
                            .request(rParams)
                            .then((res) => {
                                this.loading = false;
                                if(res.status == 200 && res.data.error == false) {
                                    this.$root.showAlert("Suscripción eliminada");
                                    this.loadSubscriptions();
                                } else {
                                    this.$root.showAlert(res.data.message[0], { variant: "danger" });
                                }
                            })
                            .catch(() => {
                                this.loading = false;
                                this.$root.handleRequestError();
                            });
                    }
                });
            },
            
            saveSubscription() {
                this.loading = true;
                const isEdit = this.editingSubscription;
                const url    = isEdit ? `/event-subscriptions/${this.subscriptionForm.id}` : '/event-subscriptions';
                const method = isEdit ? 'put' : 'post';
                
                let rParams = {
                    url: url,
                    method: method,
                    data: this.subscriptionForm
                };

                this.$root.api
                    .request(rParams)
                    .then((res) => {
                        this.loading = false;
                        if(res.status == 200 && res.data.error == false) {
                            this.$root.showAlert(isEdit ? "Suscripción actualizada" : "Suscripción creada");
                            this.$refs.subscriptionModal.hide();
                            this.loadSubscriptions();
                        } else {
                            this.$root.showAlert(res.data.message[0], { variant: "danger" });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.$root.handleRequestError();
                    });
            },
            
            loadSubscriptions() {
                this.loading = true;
                this.$root.api
                    .request({
                        url: '/event-subscriptions',
                        method: 'get'
                    })
                    .then((res) => {
                        this.loading = false;
                        if(res.status == 200 && res.data.error == false) {
                            this.subscriptions = res.data.data;
                        } else {
                            this.$root.showAlert(res.data.message[0], { variant: "danger" });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.$root.handleRequestError();
                    });
            },

            loadAllowedEvents() {
                this.loading = true;
                this.$root.api
                    .request({
                        url: '/event-subscriptions/events',
                        method: 'get'
                    })
                    .then((res) => {
                        this.loading = false;
                        if(res.status == 200 && res.data.error == false) {
                            this.availableEvents = res.data.data;
                            this.loadSubscriptions()
                        } else {
                            this.$root.showAlert(res.data.message[0], { variant: "danger" });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.$root.handleRequestError();
                    });
            },
            
            resetForm() {
                this.subscriptionForm = {
                    name: '',
                    url: '',
                    method: 'POST',
                    data: '',
                    notes: '',
                    eventId: null,
                    flowId: null,
                    platform: 'BIRD',
                    status: 'active',
                    id: null,
                    salesChannels: [],
                    suppliers: [],
                    zones: [],
                    filters: []
                };

                this.editingSubscription = false;
            },

            testSubscription(subscription) {
                if (!this.reservationIdTest) {
                    this.$root.showAlert('Ingrese un ID de reservación', { variant: 'warning' });
                    return;
                }

                this.$set(this.testLoading, subscription.id, true);
                this.$set(this.testResponse, subscription.id, null);
                
                let rParams = {
                    url: `/event-subscriptions/${subscription.id}/test`,
                    method: 'post',
                    data: {
                        reservationId: this.reservationIdTest
                    }
                };

                this.$root.api
                    .request(rParams)
                    .then((res) => {
                        this.$set(this.testLoading, subscription.id, false);
                        if (res.status == 200 && res.data.error == false) {
                            this.$root.showAlert('Webhook enviado exitosamente', { variant: 'success' });
                            this.$set(this.testResponse, subscription.id, {
                                success: true,
                                status: res.data.httpStatus || 'N/A',
                                response: res.data.response || 'Sin respuesta',
                                timestamp: new Date().toLocaleString()
                            });
                        } else {
                            this.$root.showAlert(res.data.message[0] || 'Error al enviar webhook', { variant: 'danger' });
                            this.$set(this.testResponse, subscription.id, {
                                success: false,
                                error: res.data.message[0] || 'Error desconocido',
                                timestamp: new Date().toLocaleString()
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        this.$set(this.testLoading, subscription.id, false);
                        this.$root.handleRequestError();
                        this.$set(this.testResponse, subscription.id, {
                            success: false,
                            error: 'Error de conexión',
                            timestamp: new Date().toLocaleString()
                        });
                    });
            },

            toggleTestForm(subscriptionId) {
                this.$set(this.testVisible, subscriptionId, !this.testVisible[subscriptionId]);
            },

            formatResponse(response) {
                if (typeof response === 'object') {
                    return JSON.stringify(response, null, 2);
                }
                return response;
            },

            viewLogs(subscription) {
                this.selectedSubscriptionForLogs = subscription;
                this.$nextTick(() => {
                    this.$bvModal.show('event-subscription-logs-modal');
                });
            },
        }
    }
</script>